/**
 *  dataLayer push primitive.
 *
 *  Deliberately separate from log.js. Logging goes to the server and on to CloudWatch, where the
 *  Serilog sink is gated at Warning; analytics goes to GTM. Mixing them would mean either flooding
 *  CloudWatch with funnel events or losing funnel events to that gate.
 *
 *  Nothing here may throw. A detection must never fail because analytics did.
 */

const DATA_LAYER = "dataLayer";

/**
 *  Where the visitor currently is in the flow.
 *
 *  Module scope rather than React state on purpose: the pagehide handler runs while the tree is
 *  being torn down, so it cannot rely on a component still being mounted to tell it where the
 *  visitor got to.
 */
let phase = "arrived";

export const setPhase = (value) => {
  phase = value;
};

export const getPhase = () => phase;

/**
 *  Push one event. Never throws.
 *
 *  @param {string} event  - dataLayer event name, matched by a GTM Custom Event trigger.
 *  @param {object} params - Event parameters.
 */
export const pushEvent = (event, params) => {
  try {
    window[DATA_LAYER] = window[DATA_LAYER] || [];
    window[DATA_LAYER].push({ event: event, ...(params || {}) });
  } catch (e) {
    // Swallowed on purpose. See the header.
  }
};
